/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import React, { useContext, useEffect } from 'react'
import './styles.scss'
import { JsonFormCustomContext } from '../../QuestionnareForm'
import { SchemaWithPrimaryQuestion } from '../../constants'

interface CustomRadioProps {
  id?: string
  value: string
  schema: any
  updateValue: any
  path: string
  data: any
  label: any
  errors: string
  visible: boolean
  enabled: boolean
}

export const RadioButtonsControl: React.FC<CustomRadioProps> = ({
  id,
  value,
  updateValue,
  schema,
  path,
  label,
  errors,
  visible,
  enabled
}) => {
  const primaryQuestionSchema = schema as SchemaWithPrimaryQuestion

  const myContextInstance = useContext(JsonFormCustomContext)
  const handleOptionValueChange = myContextInstance?.optionValueChangeHandler

  useEffect(() => {
    if (
      primaryQuestionSchema.primaryQuestionField === true &&
      handleOptionValueChange
    ) {
      handleOptionValueChange(value)
    }
  }, [value])

  const onChange = (value: any) => {
    updateValue(value.target.value)
  }

  const getLabelClass = () => {
    let labelClass =
      errors && errors === 'is a required property' ? 'invalid-radio-label' : ''
    labelClass = enabled ? labelClass + ' enabled' : labelClass + ' disabled'
    return labelClass
  }

  return (
    <>
      {visible && (
        <div
          style={{ textAlign: 'left', marginBottom: '1rem', marginTop: '1rem' }}
        >
          <label htmlFor={id} className='custom-radio-button-label'>
            {label}
          </label>
          <div className='custom-radio-button-container'>
            {schema?.enum.map((option: any) => (
              <div key={option.name}>
                <input
                  type='radio'
                  id={`${option.value}${label}${path}`}
                  key={option.name}
                  checked={value === option.value}
                  value={option.value}
                  onChange={onChange}
                  disabled={!enabled}
                  data-testid='custom-radio-buttons'
                />
                <label
                  htmlFor={`${option.value}${label}${path}`}
                  id={path}
                  style={{ marginRight: '10px' }}
                  className={getLabelClass()}
                >
                  {option.name}
                </label>
              </div>
            ))}
          </div>
          <div className='text-danger'>
            {errors && errors === 'is a required property' && (
              <span>Please select an option</span>
            )}
          </div>
        </div>
      )}
    </>
  )
}
